import { ChangeDetectionStrategy, Component, inject, input, output } from '@angular/core';
import { NavigationService } from '../../core/navigation';
import { NavItemComponent } from '../../ui';

/**
 * Barra di navigazione in basso sotto i 768 px (FR-028, tavola M·05): le voci `mobile` del
 * contesto e "Altro", che apre il pannello con tutte le voci. Aree di tocco di 64 px.
 */
@Component({
  selector: 'bs-bottom-nav',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NavItemComponent],
  host: { class: 'block' },
  template: `
    <nav
      aria-label="Navigazione rapida"
      data-testid="bottom-nav"
      class="fixed inset-x-0 bottom-0 z-30 border-t border-stone-200 bg-white px-2 pb-2 dark:border-stone-800 dark:bg-stone-950"
    >
      <ul class="flex">
        @for (item of navigation.mobileItems(); track item.id) {
          <li class="min-w-0 flex-1">
            <bs-nav-item
              variant="bottom"
              [label]="item.label"
              [icon]="item.icon"
              [link]="item.link"
              [exact]="item.exact ?? false"
              [testId]="'bottom-nav-' + item.id"
            />
          </li>
        }
        <li class="min-w-0 flex-1">
          <bs-nav-item
            variant="bottom"
            label="Altro"
            icon="more"
            controls="mobile-drawer"
            [expanded]="moreExpanded()"
            testId="bottom-nav-more"
            (pressed)="moreRequested.emit()"
          />
        </li>
      </ul>
    </nav>
  `,
})
export class BottomNavComponent {
  readonly moreExpanded = input(false);
  readonly moreRequested = output();
  protected readonly navigation = inject(NavigationService);
}
